import {
  MinusIcon,
  PlusIcon,
  ShirtIcon,
  TextRephraseIcon,
  ShirtFormalIcon,
  WandSparklesIcon,
} from '@buffer-mono/popcorn'

const ACTIONS = {
  generate: {
    id: 'generate',
    label: 'Generate',
    mutation: 'generateText',
    IconComponent: WandSparklesIcon,
  },
  expand: {
    id: 'expand',
    label: 'Expand',
    mutation: 'expandText',
    IconComponent: PlusIcon,
  },
  shorten: {
    id: 'shorten',
    label: 'Shorten',
    mutation: 'summarizeText',
    IconComponent: MinusIcon,
  },
  rephrase: {
    id: 'rephrase',
    label: 'Rephrase',
    mutation: 'rephraseText',
    IconComponent: TextRephraseIcon,
  },
}

const TONES = {
  casual: {
    id: 'casual',
    label: 'More Casual',
    IconComponent: ShirtIcon,
  },
  formal: {
    id: 'formal',
    label: 'More Formal',
    IconComponent: ShirtFormalIcon,
  },
}

const MODULES = {
  AIWrite: {
    id: 'AIWrite',
    component: 'AIWrite',
    name: 'Write',
  },
  AIRefine: {
    id: 'AIRefine',
    component: 'AIRefine',
    name: 'Refine',
  },
}

export { ACTIONS, MODULES, TONES }
